(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const key = 'olouioo:event:v2';
  const types = ['Self-Serve Experience', 'Hosted Experience', 'Complete Your Event', 'Event Hire'];
  const handles = ['olouioo-signature-drinks', 'olouioo-signature-coupe-tower-setup-upgrade', 'la-table', 'le-chariot', 'l-or', 'reveil', 'noir', 'lumiere', 'la-table-signature-collection', 'le-chariot-signature-collection', 'le-jardin-garden-refreshment-table', 'la-coupe-welcome-toast-table', 'le-botanique-interactive-botanical-bar'];
  const eligible = item => types.includes(item.product_type) || handles.includes(item.handle) || Boolean(item.properties?.['Event date']);
  const pair = properties => ({ date: properties?.['Event date'] || '', time: properties?.['Start time'] || '' });
  const same = (a, b) => a.date === b.date && a.time === b.time;
  const today = () => { const d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); return d.toISOString().slice(0, 10); };
  const valid = event => /^\d{4}-\d{2}-\d{2}$/.test(event.date) && event.date >= today() && /^(09|1\d|20):(00|15|30|45)$|^21:00$/.test(event.time);
  const schedule = (event, nextDay = 'Next day', hours = 3) => {
    const [h, m] = event.time.split(':').map(Number);
    const start = h * 60 + m;
    const dateAt = offset => {
      const date = new Date(event.date + 'T00:00:00Z');
      date.setUTCDate(date.getUTCDate() + offset);
      return date.toISOString().slice(0, 10).split('-').reverse().join('/');
    };
    const time = n => `${String(Math.floor(n / 60) % 24).padStart(2, '0')}:${String(n % 60).padStart(2, '0')}${n >= 2880 ? ' ' + dateAt(Math.floor(n / 1440)) : n >= 1440 ? ' ' + nextDay : ''}`;
    return { 'Event date': event.date, 'Setup date': event.date, 'Start time': event.time, 'Setup start': time(start - 120), 'Finish time': time(start + hours * 60), 'Pack-down start': time(start + hours * 60), 'Pack-down complete': time(start + hours * 60 + 60), 'Event duration': hours + ' hours active hire', 'Setup and pack-down allowance': 'Allow 1–2 hours before active hire for setup; 1 hour after for pack-down', '_olouioo_event': 'shared' };
  };
  const itemHours = item => {
    const hours = Number(item.properties?._olouioo_duration_hours) || Number(item.properties?.['Event duration']?.match(/\d+/)?.[0]) || 3;
    return Number.isInteger(hours) && ((hours >= 3 && hours <= 13) || hours === 24 || hours === 48 || hours === 72) ? hours : 3;
  };
  let state = { date: '', time: '' };
  try { const saved = JSON.parse(sessionStorage.getItem(key)); if (saved && typeof saved.date === 'string' && typeof saved.time === 'string') state = saved; } catch {}
  let eventExpanded = false;
  let revision = 0;
  let syncing = false;
  let timer;
  let tail = Promise.resolve();
  let lastPersisted = null;
  let cartRevision = 0;
  const pendingSaves = new Map();
  let status = '';
  let nextDay = 'Next day';
  async function request(path, body) {
    const response = await fetch(root() + path, { cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...(body ? { method: 'POST', body: JSON.stringify(body) } : {}) });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error('Event details could not be saved.');
    return data;
  }
  function showStatus(value) {
    status = value;
    document.querySelectorAll('[data-event-sync-status]').forEach(node => {
      node.textContent = node.dataset[value] || '';
      node.dataset.state = value;
    });
    document.querySelectorAll('[data-shared-save]').forEach(button => { button.hidden = value !== 'error'; });
  }
  function reflect() {
    syncing = true;
    document.querySelectorAll('event-booking-fields').forEach(booking => {
      const date = booking.querySelector('[data-event-date]');
      const time = booking.querySelector('[data-start-time]');
      if (!date || !time) return;
      date.readOnly = false;
      time.removeAttribute('aria-disabled');
      time.style.pointerEvents = '';
      time.removeAttribute('tabindex');
      date.value = state.date; time.value = state.time;
      date.dispatchEvent(new Event('change', { bubbles: true }));
      time.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.querySelectorAll('olouioo-event-cart').forEach(card => {
      card.querySelector('[data-shared-date]').value = state.date;
      card.querySelector('[data-shared-time]').value = state.time;
      card.querySelector('[data-shared-setup]').textContent = state.date || '—';
    });
    syncing = false;
    showStatus(status);
  }
  const ready = request('cart.js').then(cart => {
    if (!revision && !state.date && !state.time) {
      const saved = pair(cart.attributes);
      const first = cart.items.find(item => eligible(item) && item.properties?.['Event date']);
      state = saved.date && saved.time ? saved : first ? pair(first.properties) : state;
    }
    if (valid(state) && same(pair(cart.attributes), state) && cart.attributes?.['Setup date'] === state.date && (cart.items || []).filter(eligible).every(item => Object.entries(schedule(state, nextDay, itemHours(item))).every(([name, value]) => item.properties?.[name] === value))) lastPersisted = { ...state };
    reflect();
  }).catch(() => {});
  function setEvent(event) {
    const next = { date: event.date || '', time: event.time || '' };
    if (same(next, state)) return;
    state = next;
    lastPersisted = null;
    revision++;
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch {}
    reflect();
    clearTimeout(timer);
    if (!valid(state)) { showStatus(''); return; }
    showStatus('saving');
    timer = setTimeout(() => { flush().catch(() => {}); }, 250);
  }
  async function refresh(cart) {
    const { CartUpdateEvent } = await import('@theme/events');
    document.dispatchEvent(new CartUpdateEvent({}, 'olouioo-event', { itemCount: cart.item_count, sections: cart.sections, autoOpenDrawer: false }));
  }
  async function persist(event) {
    let cart = await request('cart.js');
    for (const item of cart.items) {
      if (!eligible(item)) continue;
      if ((item.properties?.['_olouioo_blocked_dates'] || '').split(/[\s,]+/).includes(event.date)) throw new Error('Unavailable event date.');
    }
    let changed = false;
    let remaining = cart.items.length * 2 + 5;
    while (remaining-- > 0) {
      const item = cart.items.find(item => eligible(item) && Object.entries(schedule(event, nextDay, itemHours(item))).some(([name, value]) => item.properties?.[name] !== value));
      if (!item) break;
      changed = true;
      cart = await request('cart/change.js', { id: item.key, quantity: item.quantity, properties: { ...(item.properties || {}), ...schedule(event, nextDay, itemHours(item)) } });
    }
    if (remaining < 0) throw new Error('Event details could not be saved.');
    if (!changed && cart.attributes?.['Event date'] === event.date && cart.attributes?.['Setup date'] === event.date && cart.attributes?.['Start time'] === event.time) return cart;
    const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(node => node.sectionId || node.dataset.sectionId).filter(Boolean))].slice(0, 5);
    cart = await request('cart/update.js', { attributes: { 'Event date': event.date, 'Setup date': event.date, 'Start time': event.time }, ...(sections.length ? { sections, sections_url: location.pathname } : {}) });
    try { await refresh(cart); } catch (error) { console.warn('Event details saved; cart display could not refresh.', error); }
    return cart;
  }
  async function flush() {
    clearTimeout(timer);
    await ready;
    const event = { ...state };
    if (!valid(event)) throw new Error('Choose a valid date and time.');
    if (lastPersisted && same(lastPersisted, event)) return;
    const saveKey = JSON.stringify(event);
    if (pendingSaves.has(saveKey)) return pendingSaves.get(saveKey);
    const task = tail.catch(() => {}).then(async () => {
      if (!same(event, state)) return;
      if (lastPersisted && same(lastPersisted, event)) return;
      showStatus('saving');
      const savedCartRevision = cartRevision;
      const panels = [...document.querySelectorAll('cart-items-component .cart-item__quantity, cart-items-component .cart-item__remove')];
      const inert = panels.map(node => node.inert);
      panels.forEach(node => { node.inert = true; });
      try {
        await persist(event);
        if (same(event, state)) { if (cartRevision === savedCartRevision) lastPersisted = { ...event }; showStatus('saved'); }
      } catch (error) {
        if (same(event, state)) showStatus('error');
        throw error;
      } finally {
        panels.forEach((node, i) => { node.inert = inert[i]; });
      }
    });
    tail = task;
    pendingSaves.set(saveKey, task);
    try { return await task; }
    finally { if (pendingSaves.get(saveKey) === task) pendingSaves.delete(saveKey); }
  }
  const hydrated = new WeakSet();
  async function hydrate(booking) {
    if (!hydrated.has(booking)) {
      hydrated.add(booking);
      const date = booking.querySelector('[data-event-date]');
      const time = booking.querySelector('[data-start-time]');
      nextDay = booking.dataset.nextDay || nextDay;
      const changed = () => {
        if (syncing) return;
        if (!date.checkValidity() || (time.value && !time.checkValidity())) return;
        setEvent({ date: date.value, time: time.value });
      };
      date.addEventListener('change', changed);
      time.addEventListener('change', changed);
    }
    await ready;
    reflect();
  }
  async function prepare(booking, data) {
    await ready;
    const event = { date: data.get('properties[Event date]'), time: data.get('properties[Start time]') };
    if (!valid(event)) throw new Error(booking.dataset.timeError);
    if ((booking.dataset.blockedDates || '').split(/[\s,]+/).includes(event.date)) throw new Error(booking.dataset.dateError);
    if (!same(event, state)) setEvent(event);
    try { await flush(); } catch { showStatus('error'); }
    if (!same(event, state)) throw new Error(booking.dataset.timeError);
    Object.entries(schedule(state, booking.dataset.nextDay, Number(booking.querySelector('[data-hire-duration]')?.value || data.get('properties[_olouioo_duration_hours]') || 3))).forEach(([name, value]) => data.set(`properties[${name}]`, value));
  }
  function tableOrderCount(cart) {
    return (cart.items || []).reduce((total, item) => total + (item.handle === 'la-table' ? Number(item.quantity) || 0 : 0), 0);
  }
  function tableOrderAllowed(cart) {
    const count = tableOrderCount(cart);
    return count === 0 || count >= 3;
  }
  function updateTableMinimum(count) {
    const allowed = count === 0 || count >= 3;
    document.querySelectorAll('[data-table-order-notice]').forEach(notice => {
      notice.hidden = allowed;
      notice.dataset.tableCount = String(count);
      const message = notice.querySelector('[data-table-order-message]');
      if (message?.dataset.template) message.textContent = message.dataset.template
        .replaceAll('__current__', String(count)).replaceAll('__remaining__', String(Math.max(0, 3 - count)));
    });
    document.querySelectorAll('[data-table-minimum-checkout]').forEach(button => {
      const wasBlocked = button.dataset.tableMinimumBlocked === 'true';
      if (!allowed) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else if (wasBlocked) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      }
      button.dataset.tableMinimumBlocked = String(!allowed);
    });
    return allowed;
  }
  function syncTableMinimum(event) {
    const data = event.detail?.data;
    if (Array.isArray(data?.items)) {
      updateTableMinimum(tableOrderCount({ items: data.items }));
      return;
    }
    for (const html of Object.values(data?.sections || {})) {
      if (typeof html !== 'string' || !html.includes('data-table-count=')) continue;
      const fragment = new DOMParser().parseFromString(html, 'text/html');
      const notice = fragment.querySelector('[data-table-count]') ||
        [...fragment.querySelectorAll('template')].map(template => template.content.querySelector('[data-table-count]')).find(Boolean);
      if (!notice) continue;
      const count = Number(notice.dataset.tableCount);
      if (Number.isSafeInteger(count) && count >= 0) { updateTableMinimum(count); return; }
    }
  }
  function reportTableMinimum(cart) {
    const allowed = updateTableMinimum(tableOrderCount(cart));
    if (!allowed) {
      const notice = [...document.querySelectorAll('[data-table-order-notice]')].find(node => node.getClientRects().length);
      notice?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      notice?.focus({ preventScroll: true });
    }
    return allowed;
  }
  class EventCart extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      const details = this.querySelector('.olouioo-event-details');
      if (details) {
        details.open = eventExpanded;
        details.addEventListener('toggle', () => { eventExpanded = details.open; });
      }
      const date = this.querySelector('[data-shared-date]');
      const time = this.querySelector('[data-shared-time]');
      date.min = today();
      nextDay = this.dataset.nextDay || nextDay;
      const changed = () => {
        if (syncing || (date.value && !date.checkValidity()) || (time.value && !time.checkValidity())) return;
        setEvent({ date: date.value, time: time.value });
      };
      date.addEventListener('change', changed);
      time.addEventListener('change', changed);
      this.querySelector('[data-shared-save]').addEventListener('click', () => flush().catch(() => {}));
      ready.then(reflect);
    }
    async checkout() {
      if (this._checkingOut) return;
      const date = this.querySelector('[data-shared-date]');
      const time = this.querySelector('[data-shared-time]');
      if (!date.checkValidity() || !time.checkValidity()) {
        const details = this.querySelector('.olouioo-event-details');
        if (details) { details.open = true; eventExpanded = true; }
        else {
          const panel = document.getElementById('cart-drawer-event');
          if (panel?.openDialog) await panel.openDialog();
        }
        if (!date.reportValidity()) return;
        time.reportValidity();
        return;
      }
      setEvent({ date: date.value, time: time.value });
      this._checkingOut = true;
      try {
        await flush();
        const currentCart = await request('cart.js');
        if (!reportTableMinimum(currentCart)) { this._checkingOut = false; return; }
        window.location.assign(root() + 'checkout');
      }
      catch { this._checkingOut = false; showStatus('error'); }
    }
  }
  document.addEventListener('cart:update', event => {
    syncTableMinimum(event);
    const source = event.detail?.data?.source;
    if (source !== 'product-form-component' && event.detail?.sourceId !== 'olouioo-event') { lastPersisted = null; cartRevision++; }
  });
  window.OlouiooEvents = { hydrate, prepare, schedule };
  if (!customElements.get('olouioo-event-cart')) customElements.define('olouioo-event-cart', EventCart);
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout') return;
    const cards = [...document.querySelectorAll('olouioo-event-cart')];
    const card = event.submitter.closest('.cart-order-summary')?.querySelector('olouioo-event-cart') || cards.find(node => node.getClientRects().length) || cards[0];
    if (!card) return;
    event.preventDefault(); event.stopImmediatePropagation();
    card.checkout();
  }, true);
})();


